import React, { useEffect, useState } from 'react';
import Amplify from 'aws-amplify';
import { Redirect } from '@reach/router';

import Layout from '../components/Global/Layout';
import Login from '../components/Login';

import AppSyncConfig from '../aws-exports';
import CheckBan from '../components/CheckBan';

Amplify.configure(AppSyncConfig);

const IndexPage = () => {
  useEffect(() => {}, []);
  const initCustomEvent = { type: null, target: null };
  const [state, setState] = useState({
    customEvent: initCustomEvent,
  });
  const customEventTrigger = (customEvent) => {
    setState({ customEvent });
    // setState({ customEvent: initCustomEvent });
  };

  return (
    <Layout
      stateEvent={state.customEvent}
      customEventTrigger={customEventTrigger}
    >
      <Login className="loginComponent" />

      <CheckBan roomId="banned" />
    </Layout>
  );
};
export default IndexPage;
